export default "__VITE_ASSET__DzY6ftvl__"